export enum FinancialConnectionRecovery {
    RECONNECT = 'reconnect',
    NEW_CONNECTION = 'new connection',
    NONE = 'none',
}
